import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'modal-reto-caducado',
  templateUrl: 'modal-reto-caducado.html'
})
export class ModalRetoCaducadoComponent implements OnInit{

  retosPerdidos: Array<any> = [];
  retosGanados: Array<any> = [];
  show: boolean= false;
  tipoGanado: boolean = false;
  private container: any;
  
  @Input('retosCaducos') retosCaducos: Observable<any>;
  _retosCaducos: Array<any> = [];
  _retoActual: any;

  constructor() {  }

  ngOnInit(): void {
    this.retosCaducos.subscribe( retos => {
      this._retosCaducos = this._retosCaducos.concat(retos);
      if(!this._retoActual){
        this.present();
      }
    });
  }


  handlerEvents(): void {

    setTimeout( () => {
      this.container = document.getElementById("modal-container-id");

      let animationEnd = (function(el) {
        let animations = {
          animation: 'animationend',
          OAnimation: 'oAnimationEnd',
          MozAnimation: 'mozAnimationEnd',
          WebkitAnimation: 'webkitAnimationEnd',
        };

        for (let t in animations) {
          if (el.style[t] !== undefined) {
            return animations[t];
          }
        }
      })(document.createElement('div'));

      this.container.addEventListener(animationEnd, () => {
        this.container.classList.remove("animated",  "bounceInLeft", "delay-2s");
        this.container.querySelector("#score").classList.add("animated",  "bounceIn", "delay-4s");
      });

    });
  }

  cerrar(){
    this.container.classList.add("animated", "bounceInLeft", "delay-2s");
    this.container.querySelector("#score").classList.remove("animated",  "bounceIn", "delay-4s");
    this.present();
  }

  present() {
    this._retoActual = this._retosCaducos.pop();
    if(this._retoActual) {
      this.show = true;
      this.handlerEvents();

    } else {
      this._retoActual = null;
      this.show = false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/modal-reto-caducado/modal-reto-caducado.ts